import { render, staticRenderFns } from "./Account2Index.vue?vue&type=template&id=750a0c39&scoped=true"
import script from "./Account2Index.vue?vue&type=script&lang=js"
export * from "./Account2Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750a0c39",
  null
  
)

export default component.exports